import type { TCatalogFilter } from './catalog-filters';

/** The i18n key segment of each filter (`menuPage.filter.{key}`). */
const FILTER_KEYS: Record<TCatalogFilter, string> = {
  all: 'all',
  hidden: 'hidden',
  'no-photo': 'noPhoto',
  'no-description': 'noDescription',
  'no-price': 'noPrice',
  discounted: 'discounted',
  scheduled: 'scheduled',
};

export function catalogFilterKey(filter: TCatalogFilter): string {
  return FILTER_KEYS[filter];
}
